import {ISessionXpedition} from './interfaces';
import {IAction} from '../interface';
import {InferActionsTypes} from '../helpers';

export const SET_SESSIONS = 'SET_SESSIONS';
export const setSessions = (sessions: ISessionXpedition[]): IAction<ISessionXpedition[]> => ({
  type: SET_SESSIONS,
  payload: sessions
});

const sessionActions = {
  setSessions
};

export type SessionActionsType = InferActionsTypes<typeof sessionActions>
